import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { Checkbox } from '@progress/kendo-react-inputs'

import { PlatformLinkPageKey } from '../../../api/Trading-Accounts/PlatformLink.Dto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const platformLinkColumns: GridColumn[] = [
  {
    title: 'Platform Link',
    field: PlatformLinkPageKey.platformLink,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    minResizableWidth: 120,
  },
  {
    title: 'Platform',
    field: PlatformLinkPageKey.platform,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    minResizableWidth: 120,
  },
  {
    title: 'Operating System',
    field: PlatformLinkPageKey.operatingSystem,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    minResizableWidth: 120,
  },
  {
    title: 'Company',
    field: PlatformLinkPageKey.company,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={props.dataItem?.tickmillCompany?.id}>
            {props.dataItem.client?.tickmillCompany?.name}
          </CompanyTag>
        </td>
      )
    },
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    minResizableWidth: 120,
  },
  {
    title: 'Order',
    field: PlatformLinkPageKey.order,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    minResizableWidth: 120,
  },
  {
    title: 'Enabled',
    field: PlatformLinkPageKey.enabled,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    minResizableWidth: 120,
    cell: (item: GridCellProps) => {
      return (
        <td>
          <Checkbox value={item.dataItem.enabled} disabled />
        </td>
      )
    },
  },
]
